<script setup lang="ts">
import { cn } from '@ui/lib/utils.js';
import { SIDEBAR_WIDTH_ICON } from '@ui/components/core/p-sidebar/utils.js';
import { PSidePanelRail, useSidePanelProvider } from '@ui/components/core/p-side-panel/index.js';

interface PSidePanelProps {
    side?: 'left' | 'right';
    overlay?: boolean;
    width?: string;
    glossy?: boolean;
}
const open = defineModel<boolean>({ default: false });

withDefaults(defineProps<PSidePanelProps>(), {
    side: 'left',
    width: '16rem',
});
useSidePanelProvider(open);
</script>

<template>
    <div
        :style="{
            '--sidebar-width': width,
            '--sidebar-width-icon': SIDEBAR_WIDTH_ICON,
        }"
        class="group peer hidden md:block"
        :data-state="open ? 'expanded' : 'collapsed'"
        :data-collapsible="!open && 'offcanvas'"
        data-variant="sidebar"
        :data-side="side"
    >
        <div
            v-if="!overlay"
            class="duration-200 relative h-full w-(--sidebar-width) transition-[width] ease-linear group-data-[collapsible=offcanvas]:w-0 group-data-[side=right]:rotate-180 group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
        ></div>
        <div
            :class="
                cn(
                    glossy
                        ? 'bg-gray-100/10 bg-clip-padding backdrop-filter backdrop-blur-xs bg-blend-overlay'
                        : 'bg-surface-background',
                    side === 'left'
                        ? 'left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]'
                        : 'right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]',
                    'duration-200 absolute inset-y-0 z-30 hidden h-full w-(--sidebar-width) transition-[left,right,width] ease-linear md:flex group-data-[collapsible=icon]:w-(--sidebar-width-icon) border-border-default group-data-[side=left]:border-r group-data-[side=right]:border-l border-r-0',
                )
            "
        >
            <div
                data-sidepanel="sidepanel"
                class="flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-border-default group-data-[variant=floating]:shadow"
            >
                <slot />
                <PSidePanelRail />
            </div>
        </div>
    </div>
</template>
